export enum SbrParamsEnum {
  AUTO_CLOSE_TIME = 'AutoCloseTime',
  ALARM_LIGHT_DELAY = 'AlarmLightDelay',
  ALARM_LIGHT_DURATION = 'AlarmLightDuration',
  SERVICE_INFO = 'ServiceInfo',
}
